<template>
  <BDropdown v-slot:default="{ isOpen, toggle, close }">
    <div class="relative">
      <basic-button @click="toggle" size="sm" leadingIcon="filter" color="white">
        <span>Filtern</span>
        <span
          v-if="hasActiveFilter"
          class="border-l ml-2 pl-2 text-green-600 font-semibold"
        >{{amountOfActiveFilter}}</span>
      </basic-button>

      <div
        v-if="isOpen"
        class="mt-3 bg-white rounded absolute shadow-xl border border-gray-200 overflow-hidden w-60"
      >
        <div class="flex justify-between items-center py-2 px-3 bg-gray-50">
          Filter
          <basic-button
            v-if="hasActiveFilter"
            @click="resetFilter(close)"
            size="xs"
            color="white"
          >Zurücksetzen</basic-button>
        </div>
        <slot />
        <div class="py-2 px-3 bg-gray-50 border-t border-gray-200">
          <basic-button @click="submit(close)" size="xs">Anwenden</basic-button>
        </div>
      </div>
    </div>
  </BDropdown>
</template>

<script>
import _pickBy from "lodash/fp/pickBy";
import _mapValues from "lodash/fp/mapValues";
import _compose from "lodash/fp/compose";

import _isUndefined from "lodash/isUndefined";
import _each from "lodash/each";
import _size from "lodash/size";

import BDropdown from "@/components/BDropdown";

export default {
  props: {
    filter: {
      type: Object
    }
  },

  components: { BDropdown },

  data() {
    return {
      registeredFilter: {}
    };
  },

  provide() {
    return {
      registerFilter: this.registerFilter
    };
  },

  watch: {
    filter: {
      handler() {
        this.updateAllFilter();
      },
      deep: true
    }
  },

  computed: {
    hasActiveFilter() {
      return _size(this.filter) > 0;
    },

    amountOfActiveFilter() {
      return _size(this.filter);
    },

    hasRegisteredFilter() {
      return _size(this.registeredFilter) > 0;
    }
  },

  methods: {
    registerFilter(filter) {
      this.$set(this.registeredFilter, filter.name, filter);
      this.updateAllFilter();
    },

    submit(closeDropdown) {
      let filter = _compose(
        _mapValues(filter => filter.getValue()),
        _pickBy(filter => filter.getActive())
      )(this.registeredFilter);

      this.$emit("input", filter);

      closeDropdown();
    },

    updateAllFilter() {
      _each(this.registeredFilter, filter => {
        filter.setValue(
          // If undefined provide empty string
          _isUndefined(this.filter[filter.name]) ? "" : this.filter[filter.name]
        );
      });
    },

    resetFilter(closeDropdown) {
      this.$emit("input", {});

      closeDropdown();
    }
  }
};
</script>